<template>
    <transition name="msgbox-fade">
        <div class="authModule__wrapper" tabindex="-1" v-if="visible" role="dialog" aria-modal="true"
             :aria-label="$type || 'dialog'" style="z-index: 998">
            <sign-in v-if="$type === 'SignIn'"/>
            <register v-if="$type === 'Register'"/>
            <div class="v-modal" tabindex="0" style="z-index: 998;" v-if="visible"></div>
        </div>
    </transition>

</template>
<script type="text/babel">
  import SignIn from './signIn'
  import Register from './register'

  export default {
    props: {
      visible: {
        default: false
      },
      $type: {
        default: 'SignIn'
      }
    },
    components: {
      SignIn,
      Register
    }
  }
</script>
<style lang="scss" scoped>
    .authModule__wrapper {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        text-align: center;

    }
</style>
